import extend from "../../services/extend";

/**
 * @ngdoc directive
 * @name vue.directive:vReader
 * This will handle view more and less
 */

export default (vue) => extend(vue, (vue) => {
    if ( vue.el.parentNode.clientHeight < vue.el.clientHeight ) {
        vue.set(vue.exp, false);
    }
});